<script>
  import { onMount } from "svelte";
  import { fade } from "svelte/transition";
  import SmallButton from "../SmallButton/SmallButton.svelte";
  import ErrorMessage from "../ErrorMessage/ErrorMessage.svelte";
  import EventCard from "../EventCard/EventCard.svelte";
  import { t } from './../../i18n';

  let pageNumber = 1;
  let requestPending = false;
  let pageSize = 3;
  let moreEventsAvailable = false;
  let events = [];
  let error = false;

   
  function handleLoadMore() {
    if (moreEventsAvailable && !requestPending) {
      pageNumber += 1;
      fetchEvents();
    }
  }

  async function fetchEvents() {
    try {
      requestPending = true;
      const eventsRequest = await fetch(
        `${API_URL}/events?pageSize=${pageSize}&pageNumber=${pageNumber}`
      );
      if (eventsRequest.status === 200) {
        const data = await eventsRequest.json();
        events = [...events, ...data.results];
        moreEventsAvailable = data.totalPages > pageNumber;
      } else {
        throw new Error("API returned unexpected status.");
      }
      requestPending = false;
    } catch (e) {
      requestPending = false;
      console.log(e);
      error = true;
    }
  }

  onMount(async () => {
    fetchEvents();
  });

</script>

<div class="c-event-grid">
  {#if !error}
    <ul class="c-event-grid__grid">
      {#each events as event}
        <li class="c-event-grid__item" transition:fade>
          <EventCard {...event} />
        </li>
      {/each}
    </ul>
    {#if moreEventsAvailable}
      <div class="c-event-grid__load-more-wrap">
        <SmallButton onClick={handleLoadMore} disabled={requestPending}>
          {$t('load_more_button_text')}
        </SmallButton>
      </div>
    {/if}
    {#if events.length === 0}
      <ErrorMessage message={$t('error_state_no_events')}/>
    {/if}
  {:else}
    <p>{$t('generic_error')}</p>
  {/if}
</div>

<style>
  .c-event-grid {
    background-color: var(--neutral-050);
    padding: 32px 20px;
  }

  .c-event-grid__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 16px;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    max-width: 100%;
    width: 1200px;
    min-width: 0;
  }

  @media (max-width: 1024px) {
    .c-event-grid__grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    .c-event-grid__grid {
      grid-template-columns: 1fr;
    }
  }

  .c-event-grid__item {
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 0;
  }

  .c-event-grid__load-more-wrap {
    padding: 32px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
